import React from 'react';
import { Line } from 'react-chartjs-2';
import WhoopPuckAttribution from '@/components/shared/WhoopPuckAttribution';

interface RecoveryTabProps {
  athleteData: any;
  isDark: boolean;
  generateRecoveryChart: () => any;
  getChartOptions: (title: string, hasSecondaryAxis?: boolean) => any;
}

const RecoveryTab: React.FC<RecoveryTabProps> = ({ athleteData, isDark, generateRecoveryChart, getChartOptions }) => {
  return (
    <div className={`${isDark ? 'bg-gray-800/80' : 'bg-white/80'} backdrop-blur-lg rounded-2xl p-8 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl`}>
      <div className="flex flex-col h-96 mb-6">
        <Line
          data={generateRecoveryChart()}
          options={getChartOptions('Recovery & HRV Trends', true)}
        />
        <WhoopPuckAttribution />
      </div>
    </div>
  );
};

export default RecoveryTab; 